import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { DataAmigavel } from '@/shared/utils/datas';
import {
  GetEventosInstitucionais,
  ReadEventoInstitucionalDto,
} from '@/modules/business/evento-institucional/evento-institucional.service';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useEffect, useState } from 'react';

export default function EventoInstitucionalIndex() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadEventoInstitucionalDto[], number]>();
  const tableState = useDataTableState('data_inicial');

  const handleBuscar = () => {
    const termo = tableState.filter.trim();
    GetEventosInstitucionais(
      (tableState.currentPage - 1) * tableState.pageSize,
      tableState.pageSize,
      termo || undefined,
    )
      .then((result) => {
        if (result) setRegistros([result.objects, result.count]);
      })
      .catch((res) => toast.error(String(res) || ''));
  };

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({
      primary: { label: 'Cadastrar', href: Links.EventoInstitucional_Criar, onClick: () => {} },
      secondary: {
        label: 'Relatório',
        href: Links.EventoInstitucional_Relatorio,
        onClick: () => {},
      },
    });
    return () => setActions({});
  }, [setActions]);

  const colunas: Column<ReadEventoInstitucionalDto>[] = [
    { key: 'titulo', header: 'Título' },
    {
      key: 'data_inicial',
      header: 'Início',
      render: (row) => <>{DataAmigavel(row.data_inicial)}</>,
    },
    {
      key: 'data_final',
      header: 'Fim',
      render: (row) => <>{DataAmigavel(row.data_final)}</>,
    },
    {
      key: 'descricao',
      header: 'Descrição',
      render: (row) => <>{row.descricao || '-'}</>,
    },
    {
      key: 'acoes',
      header: 'Ações',
      render: (row) => (
        <Link className="link-secondary" to={`${Links.EventoInstitucional_Editar}/${row.id}`}>
          Editar
        </Link>
      ),
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Eventos institucionais</h3>
          <span className="blockquote-footer pb-4 text-end">
            Mutirões, posses e demais eventos que podem vincular ausências.
          </span>
        </div>
        <hr className="pb-4" />

        {registros && (
          <DataTable
            columns={colunas}
            data={registros[0]}
            initialSortKey="data_inicial"
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros[1]}
          />
        )}
      </div>
    </>
  );
}
